import { PublicRoutes } from "@/constants/routes";
import { t } from "@/context/language";
import { trackEvent } from "@/lib/dataLayer";
import { PRESS_ARTICLES } from "../constants/pressArticles";
import { NavMenu, type NavMenuItem } from "./navMenu";

// Quantas matérias cabem no painel (uma por coluna).
const MAX_ARTICLES = 4;

export const NewsroomMenu = () => {
  // Casado pelo veículo, como em PressHighlights: matéria sem asset some do
  // menu em vez de virar um card sem link.
  const items: NavMenuItem[] = t.press.items
    .filter(item => PRESS_ARTICLES[item.outlet])
    .slice(0, MAX_ARTICLES)
    .map(item => ({
      key: item.outlet,
      title: item.outlet,
      description: item.title,
      href: PRESS_ARTICLES[item.outlet].url,
      onSelect: () =>
        trackEvent({ event: "press_article_click", outlet: item.outlet }),
    }));

  return (
    <NavMenu
      label={t.header.nav.press}
      items={items}
      footerText={t.press.title}
      footerCta={{ label: "Ver a newsroom", to: PublicRoutes.NEWSROOM }}
    />
  );
};
